import {
  Waves, Dumbbell, Bell, Car, Flower2, ShieldCheck,
  Umbrella, UtensilsCrossed, Anchor, Building2,
  Laptop, Coffee, Trophy, Thermometer, Wifi,
  Zap, Users, Bike, TreePine, Sofa, Wind,
  Moon, Sun, Camera, Footprints, Truck,
} from "lucide-react";
import { useAppContext } from "../../context/AppContext";

const ICON_MAP = [
  [["pool", "swimming", "aqua"],       Waves],
  [["beach", "sea"],                   Umbrella],
  [["gym", "fitness", "sport"],        Dumbbell],
  [["concierge", "reception", "bell"], Bell],
  [["parking", "garage", "car"],       Car],
  [["smart home", "automation"],       Wifi],
  [["security", "guard", "cctv"],      ShieldCheck],
  [["garden", "landscape", "green"],   Flower2],
  [["park", "forest", "tree"],         TreePine],
  [["restaurant", "dining", "food"],   UtensilsCrossed],
  [["marina", "yacht", "boat"],        Anchor],
  [["rooftop", "terrace", "sky"],      Building2],
  [["co-work", "cowork", "office"],    Laptop],
  [["café", "cafe", "coffee"],         Coffee],
  [["club", "lounge"],                 Trophy],
  [["sauna", "spa", "steam", "therm"], Thermometer],
  [["playground", "kids", "child"],    Bike],
  [["community", "social"],            Users],
  [["sofa", "seating", "lobby"],       Sofa],
  [["air", "ac", "cooling"],           Wind],
  [["night", "moon"],                  Moon],
  [["solar", "sun"],                   Sun],
  [["cctv", "camera", "surveillance"], Camera],
  [["walk", "promenade", "path"],      Footprints],
  [["delivery", "moving"],             Truck],
];

function getIcon(amenity) {
  const key = amenity.toLowerCase();
  for (const [keywords, Icon] of ICON_MAP) {
    if (keywords.some((k) => key.includes(k))) return Icon;
  }
  return Zap;
}

export default function ProjectAmenities({ p }) {
  const { lang } = useAppContext();

  if (!p.amenities?.length) return null;

  return (
    <section id="pd-amenities" className="pd-section">
      <div className="fadeUp" style={{ marginBottom: "3rem" }}>
        <span className="pd-section-label">
          {lang === "en" ? "Lifestyle" : "نمط الحياة"}
        </span>
        <h2 className="pd-section-title">
          {lang === "en" ? "World-Class Amenities" : "مرافق عالمية المستوى"}
        </h2>
        <div className="pd-section-bar" />
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(148px, 1fr))",
          gap: "1rem",
        }}
      >
        {p.amenities.map((amenity, i) => {
          const Icon = getIcon(amenity);
          return (
            <div key={i} className={`pd-amenity fadeUp d${Math.min(i + 1, 6)}`}>
              <div
                style={{
                  width: 50,
                  height: 50,
                  borderRadius: 14,
                  background:
                    "linear-gradient(135deg,rgba(201,168,76,.15),rgba(201,168,76,.05))",
                  border: "1px solid rgba(201,168,76,.12)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Icon size={22} color="var(--gold)" strokeWidth={1.5} />
              </div>
              <span
                style={{
                  fontFamily: "var(--sans)",
                  fontSize: ".82rem",
                  color: "var(--navy)",
                  fontWeight: 500,
                  lineHeight: 1.4,
                }}
              >
                {amenity}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
